import showerSvg from '../assets/shower.svg?raw';
import ShowerIcon from '../../../assets/icons/shower.svg?react';
import { defineSketchObjectType, registerSketchObjectType } from '../registry';
import { SketchObjectAnchorKind, SketchObjectCategory } from '../types';
import { t } from '../../translation/markers';

registerSketchObjectType(
  defineSketchObjectType({
    id: 'shower',
    label: t('Shower'),
    category: SketchObjectCategory.BATHROOM,
    anchor: SketchObjectAnchorKind.POINT,
    constraint: { kind: 'FREE' },
    defaultSize: { width: 0.9, depth: 0.9 },
    params: {},
    glyph: { kind: 'svg', assetKey: 'shower', svgSource: showerSvg },
    icon: ShowerIcon,
  }),
);
